import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import EmailIcon from "@mui/icons-material/Email";

import { SectionTitle, Copyright, ExternalLink } from "src/library/components/exports";
import { HACKATHON_EMAIL_ADDRESS } from "src/library/constants";

export default function ContactUs() {
  const theme = useTheme();
  const isLarge = useMediaQuery(theme.breakpoints.up("lg"));

  return (
    <Box>
      <SectionTitle title="Contact Us" />
      <Grid container direction="column" spacing={2}>
        <Grid item container justifyContent="center" spacing={3}>
          <Grid item>
            <ExternalLink link="https://www.linkedin.com/company/entain-australia/">
              <IconButton
                aria-label="Link to Entain Australia LinkedIn"
                size={isLarge ? "large" : "medium"}
              >
                <LinkedInIcon
                  aria-label="LinkedIn Icon"
                  sx={{ color: "common.white", fontSize: isLarge ? "2rem" : "1em" }}
                />
              </IconButton>
            </ExternalLink>
          </Grid>
          <Grid item>
            <ExternalLink link={`mailto: ${HACKATHON_EMAIL_ADDRESS}`}>
              <IconButton
                aria-label="Link to Entain Australia Hackathon Email"
                size={isLarge ? "large" : "medium"}
              >
                <EmailIcon
                  aria-label="Email Icon"
                  sx={{ color: "common.white", fontSize: isLarge ? "2rem" : "1em" }}
                />
              </IconButton>
            </ExternalLink>
          </Grid>
        </Grid>
        <Grid item container justifyContent="center" spacing={2}>
          <Grid item>
            <ExternalLink
              link="https://hackathon.entaingroup.com.au/Connectathon-Code-of-Conduct-2022.pdf"
              style={{ color: "white", textDecoration: "none" }}
            >
              <Typography variant="caption">Code of Conduct</Typography>
            </ExternalLink>
          </Grid>
          <Grid item>
            <ExternalLink
              link="https://hackathon.entaingroup.com.au/Privacy-Policy-v10-clean-2021.09.14.pdf"
              style={{ color: "white", textDecoration: "none" }}
            >
              <Typography variant="caption">Privacy Policy</Typography>
            </ExternalLink>
          </Grid>
          <Grid item>
            <Copyright />
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}
